import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TradesListLayer from "../components/TradesListLayer";

const TradesPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Trades">

        {/* TradesListLayer */}
        <TradesListLayer />
      </MasterLayout>
    </>
  );
};

export default TradesPage;
